import axios from 'axios';

let config = {
    baseURL: 'https://kifapi.enssol.tech'
};

const _axios = axios.create(config);
const allowedPaths = ["/signin", "/forgot-password", "/detail"];

/** CCN/upstream failures must not clear the Enssol session. */
const UPSTREAM_API_PREFIXES = ['/api/detailed/', '/api/ccn-redirect', '/api/config/'];

function isUpstreamFailure(error) {
    const url = error.config?.url || '';
    return UPSTREAM_API_PREFIXES.some((prefix) => url.includes(prefix));
}

/** True when our Enssol JWT session failed — never for CCN/upstream routes. */
function shouldLogoutOn401(error) {
    if (isUpstreamFailure(error)) {
        return false;
    }
    return true;
}

_axios.interceptors.request.use(
    function (config) {
        if (!config.url.includes('/api/signin') && !config.url.includes('/api/signup')) {
            if (localStorage.token || sessionStorage.token) {
                let token = localStorage.token ? localStorage.token : sessionStorage.token;
                config.headers.Authorization = 'Bearer ' + token;
            }
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // Session expired / missing JWT — logout only for real auth failures, not CCN upstream errors
        if (error.response && error.response.status === 401 && shouldLogoutOn401(error)) {
            const currentPath = window.location.pathname;
            if (!allowedPaths.includes(currentPath)) {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/signin';
            }
            return Promise.reject({
                message: 'Αποτυχία πιστοποίησης. Παρακαλώ συνδεθείτε ξανά.',
                status: 401
            });
        }

        // CCN/upstream errors: keep session, pass error to the caller
        if (error.response && (error.response.status === 401 || error.response.status === 502) && isUpstreamFailure(error)) {
            return Promise.reject(error);
        }

        // Network errors — do not clear session (transient failures should not sign the user out)
        if (error.response == null) {
            return Promise.reject({
                message: 'Σφάλμα δικτύου. Παρακαλώ ελέγξτε τη σύνδεσή σας.',
                status: 0
            });
        }

        // Preserve original axios error for callers (err.response.data.error / message)
        if (error.response && [400, 401, 403, 404, 422, 500, 502].includes(error.response.status)) {
            return Promise.reject(error);
        }

        // For other errors, return a simple error object
        return Promise.reject({
            message: 'Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
            status: error?.response?.status || 500
        });
    }
);

export const axiosInstance = _axios;
